import { initNavigationCitySelect } from './NavigationCitySelect/NavigationCitySelect';
import '../NavigationMenu/NavigationMenu';

initNavigationCitySelect();
